import SvgAlertCircle from "@uui/AlertCircle";

import { styled } from "@mui/material";

import TooltipWrapper from "@rui/TooltipWrapper";

export const AlertIcon = styled(SvgAlertCircle)(({ theme }) => ({
  backgroundColor: theme.palette.shades.orange[50],
  color: theme.palette.shades.orange[500],
  borderRadius: "50%",
  padding: theme.spacing(0.5),
}));

const TOOLTIP_TITLE =
  "We believe you own this video call. Add Read to take ownership of the Meeting Report and manage sharing.";
export const NoRoleIcon = () => {
  return (
    <TooltipWrapper title={TOOLTIP_TITLE}>
      <AlertIcon />
    </TooltipWrapper>
  );
};
